/**
 * Privacy-conscious meeting logs. No media, tokens, or display names.
 */
export function createMeetingLogger(sessionId) {
  return function logMeeting(event, fields) {
    const entry = {
      ts: new Date().toISOString(),
      sessionId: sessionId || "",
      event,
    };
    if (fields && typeof fields === "object") {
      Object.keys(fields).forEach((key) => {
        const value = fields[key];
        if (value == null) return;
        if (typeof value === "string" || typeof value === "number" || typeof value === "boolean") {
          entry[key] = value;
        }
      });
    }
    console.info("[biz-meeting]", entry);
    return entry;
  };
}
